import { Box, Button, Dialog, DialogContent, TextField } from '@mui/material'
import React from 'react'

export default function ConfirmDialogPlancampaign({ open, setOpen, rows, handleAdd , BranchNo, branchName, campaignsName }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                        ข้อมูลใบตรวจการปฏิบัติงาน
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                
                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={branchName?.find((x) => x?.BranchNo === BranchNo)?.NranchName} variant="standard" fullWidth disabled
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </Box>

                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="labelInput">โครงการ</label>
                
                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={campaignsName} variant="standard" fullWidth disabled
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </Box>
                    </div>


                </div>

                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-bordered table-hover ">
                            <thead>
                                <tr>

                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>จังหวัด</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>พันธุ์/ชั้นพันธุ์</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>ราคารวมค่าขนส่ง (บาท/กิโลกรัม)</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>จำนวนเมล็ดพันธุ์ (กิโลกรัม)</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>จำนวนเงินค่าเมล็ดพันธุ์ (บาท)</th>
                                    <th scope="col " colspan="5" class="text-center" style={{
                                        position: 'inherit',
                                    }}>คุณภาพ</th>
                                </tr>
                                <tr>

                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ความงอก (%)</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>เมล็ดพันธุ์สุทธิ (%)</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>พันธุ์ปน (จำนวนเมล็ดใน 500 กรัม)</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ข้าวแดง (จำนวนเมล็ดใน 500 กรัม)</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ความชื้น (%)</th>
                                </tr>

                            </thead>
                            <tbody class="">
                                {rows?.map((d) => (
                                    <tr >

                                        <td class="text-center">{d?.Province}</td>
                                        <td class="text-center">{d?.CatalogName} / {d?.ItemClass}
                                        </td>
                                        <td class="text-center">{parseFloat(d?.TotalPrice).toFixed(2)
                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">{d?.Qty}</td>
                                        <td class="text-center">{parseFloat(d?.SalePrice).toFixed(2)
                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">{d?.Germin}</td>
                                        <td class="text-center">{d?.NetPercent}</td>
                                        <td class="text-center">{d?.Mixed}</td>
                                        <td class="text-center">{d?.RedRice}</td>
                                        <td class="text-center">{d?.Humid}</td>

                                    </tr>

                                ))}

                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>

    )
}
